exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-slider > .vux-indicator-center {\r\n  line-height: .16rem;\n}\n.vux-slider > .vux-indicator > a > .vux-icon-dot, .vux-slider .vux-indicator-right > a > .vux-icon-dot {\r\n  opacity: .5;\r\n  background-color: #fff !important;\n}\n.vux-slider > .vux-indicator > a > .vux-icon-dot.active, .vux-slider .vux-indicator-right > a > .vux-icon-dot.active {\r\n  opacity: 1;\r\n  width: 0.3rem;\n}\n.swiper-img {\r\n  width: 100%;\r\n  height: 100%;\n}\r\n", ""]);

// exports
